import { useQuery } from 'react-query';
import { useFetchQuery } from '../../../helpers/api';
import { type Case } from './useGetCases';

type CaseStatus = {
  status: 'CLEAR' | 'PENDING';
  message: 'Success';
};

type UseGetCaseStatusResult = {
  caseStatus: CaseStatus | undefined;
  isLoading: boolean;
  error: Error | undefined;
};

type UseGetCaseStatusResponse = {
  data: CaseStatus;
};

export const useGetCaseStatus = (
  caseId: Case['id'],
  enabled: boolean,
): UseGetCaseStatusResult => {
  const { fetchQuery } = useFetchQuery();

  const { data, isLoading, error } = useQuery<UseGetCaseStatusResponse>({
    queryKey: ['case_status', caseId],
    queryFn: fetchQuery({ path: `/v2/cases/${caseId}/consultForm/status` }),
    enabled,
    refetchInterval: data => (data?.data?.status === 'PENDING' ? 1000 : false),
    refetchOnMount: true,
    refetchOnWindowFocus: true,
    cacheTime: 0,
  });

  return {
    caseStatus: data?.data as CaseStatus | undefined,
    isLoading,
    error: error as Error | undefined,
  };
};
